import angular from 'angular';

import { WizardNomadAngular } from './WizardNomad';

angular.module('portainer.app').component('wizardNomad', WizardNomadAngular);
